export const DATE_FORMAT_RETURN_DEADLINE: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
}
